import { HotelListRequest, HotelListResponse } from 'proto/Api/Hotel/HotelList';
import { ResponseStatus } from 'proto/Api/ResponseStatus';

import { HotelListView } from '../../component/Accommodation/List/__partials/List/types';

import {
    getStateForPollingFailure,
    getUpdatedStateForAccommodationList,
    triggerNextAccommodationListFetch,
} from './__helper/reducer';
import {
    AccommodationListAction,
    AccommodationListReducerAction,
    ReducerState,
} from './types';

const EMPTY_RESPONSE = HotelListResponse.fromPartial({});

export const createInitialState = (): ReducerState => ({
    requestData: HotelListRequest.fromPartial({}),
    responseData: EMPTY_RESPONSE,
    view: HotelListView.FakeTiles,
    isLoading: true,
    pollingUrl: '',
    pollingFinished: false,
    listCallRunning: false,
    timeoutNotified: false,
    searchStatus: null,
});

export const AccommodationListReducer = (
    state: ReducerState,
    action: AccommodationListReducerAction
): ReducerState => {
    switch (action.type) {
        case AccommodationListAction.StartNewSearch:
            return {
                responseData: EMPTY_RESPONSE,
                view: HotelListView.FakeTiles,
                isLoading: true,
                // new requestData triggers fetchHotelList call
                requestData: HotelListRequest.fromPartial({
                    clientId: action.payload.clientId,
                    transactionId: action.payload.transactionId,
                    searchUrl: action.payload.searchUrl,
                    isInitialRequest: true,
                    isWithTravelExperts: true,
                    isWithTravelTicker: true,
                    isWithServiceInformation: true,
                }),
                // clear poll url, will be set from first response
                pollingUrl: '',
                pollingFinished: false,
                // after this there will be definitely a running list call
                listCallRunning: true,
                timeoutNotified: false,
                pendingRequest: undefined,
                lastClickedHotel: undefined,
                searchStatus: action.payload.scope,
            };
        case AccommodationListAction.PollError:
            return action.payload
                ? state
                : getStateForPollingFailure(state, ResponseStatus.Error);
        case AccommodationListAction.PollTimeout:
            return action.payload
                ? {
                      ...state,
                      timeoutNotified: true,
                  }
                : getStateForPollingFailure(
                      state,
                      ResponseStatus.Timeout,
                      ResponseStatus.Timeout
                  );
        case AccommodationListAction.PollUpdate:
            return triggerNextAccommodationListFetch(
                {
                    ...state.requestData,
                    isInitialRequest: false,
                    isWithTravelTicker: !state.responseData.travelTickerList,
                    isWithTravelExperts: !state.responseData.travelExpertList,
                    isWithServiceInformation:
                        !state.responseData.serviceInformation,
                },
                state
            );
        case AccommodationListAction.PollFinished:
            return {
                ...triggerNextAccommodationListFetch(
                    {
                        ...state.requestData,
                        isInitialRequest: false,
                        isFinalRequest: true,
                        isWithTravelTicker:
                            !state.responseData.travelTickerList,
                        isWithTravelExperts:
                            !state.responseData.travelExpertList,
                        isWithServiceInformation:
                            !state.responseData.serviceInformation,
                    },
                    state
                ),
                pollingFinished: true,
            };
        case AccommodationListAction.UpdateAccommodationList:
            return getUpdatedStateForAccommodationList(action.payload, state);
        case AccommodationListAction.UpdateLastClickedHotel:
            return {
                ...state,
                lastClickedHotel: action.payload,
            };
    }
};
